<!--
~ Copyright (C) 2020 DV Bern AG, Switzerland
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as
~ published by the Free Software Foundation, either version 3 of the
~ License, or (at your option) any later version.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. If not, see <https://www.gnu.org/licenses/>.
-->
@if (canSeeFreigegebenText | async) {
    <p [innerHTML]="'LATS_FREIGEGEBEN_AN_KANTON' | translate"></p>
}
@if (canSeeAbgeschlossenText | async) {
    <p [innerHTML]="'LATS_ABGESCHLOSSEN' | translate"></p>
}

@if (container && (isZweitPruefungAndSameUserAsPruefung() | async)) {
    <dv-warning [text]="'WARNING_SAME_ZWEITPRUEFUNG_USER'"></dv-warning>
}

<div class="actions">
    @if (canSeeFreigabeButton | async) {
        <dv-loading-button
            [buttonDisabled]="(isInBearbeitungGemeinde() | async) === false"
            (buttonClick)="freigeben()"
            type="button"
            data-test="freigabe-pruefung-kanton"
        >
            <span translate>LATS_FREIGABE_PRUEFUNG_KANTON</span>
        </dv-loading-button>
    }
    @if (canSeeGeprueftButton | async) {
        <dv-loading-button
            [buttonDisabled]="!isReadyForGeprueft()"
            type="button"
            (buttonClick)="geprueft()"
            data-test="freigabe-geprueft-von-kanton"
        >
            <span translate>LATS_GEPRUEFT_KANTON</span>
        </dv-loading-button>
    }
    @if ((canSeeGeprueftButton | async) && !isAlreadyInZweitpruefung()) {
        <dv-loading-button
            [buttonDisabled]="!isReadyForGeprueft()"
            (buttonClick)="inZweitpruefungGeben()"
        >
            <span translate>ZUR_ZWEITPRUEFUNG</span>
        </dv-loading-button>
    }
    @if (canSeeGeprueftButton | async) {
        <dv-loading-button
            [buttonDisabled]="(isInPruefungKanton() | async) === false"
            type="button"
            class="secondary"
            (buttonClick)="zurueckAnGemeinde()"
            data-test="zurueck-an-die-gemeinde"
        >
            <span translate>ZURUECK_AN_GEMEINDE_TITLE</span>
        </dv-loading-button>
    }
    @if (canSeeZurueckInPruefungButton | async) {
        <dv-loading-button
            type="button"
            class="secondary"
            (buttonClick)="zurueckInPruefung()"
        >
            <span translate>ZURUECK_IN_PRUEFUNG_TITLE</span>
        </dv-loading-button>
    }
</div>
